<div class="teams-reports">

  <div class="reports-content">

    <div class="report-titles">
      <h2>teams performance</h2>
      <h3>click on the team whose performance you want to see</h3>
    </div>


    <ul class="teams-list">
      <li *ngFor="let team of teams">
        <a [routerLink]="['/reports/team/' + team.id]">
          {{team.name}}
        </a>
      </li>

    </ul>

  </div>

</div>
